// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31E5D","signatureBlock":"Footer_signatureBlock__eABih","signature":"Footer_signature__1wKpZ"};